import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogPaymentMode } from "../../store/catalog/actions";
export var GetCatalogPaymentMode = function (trigger, enable, page, limit, clientId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogPaymentMode: (_a = state.Catalog.responseGetCatalogPaymentMode) === null || _a === void 0 ? void 0 : _a.data,
            loadingGetCatalogPaymentMode: state.Catalog.loadingGetCatalogPaymentMode,
            errorGetCatalogPaymentMode: state.Catalog.errorGetCatalogPaymentMode,
        });
    }), responseGetCatalogPaymentMode = _a.responseGetCatalogPaymentMode, loadingGetCatalogPaymentMode = _a.loadingGetCatalogPaymentMode, errorGetCatalogPaymentMode = _a.errorGetCatalogPaymentMode;
    useEffect(function () {
        if (trigger) {
            dispatch(getCatalogPaymentMode({
                enable: enable,
                page: page,
                limit: limit,
                type: "CATALOG_PAYMENT_MODE",
                clientId: clientId,
            }));
        }
    }, [trigger, enable, page, limit, clientId]);
    return {
        responseGetCatalogPaymentMode: responseGetCatalogPaymentMode,
        loadingGetCatalogPaymentMode: loadingGetCatalogPaymentMode,
        errorGetCatalogPaymentMode: errorGetCatalogPaymentMode,
    };
};
